import { Faker } from '@faker-js/faker';

export const randomProfilePhoto =
  (faker: Faker) =>
  ({
    gender = faker.helpers.arrayElement(['men', 'women']),
    number = faker.datatype.number(100),
  } = {}) =>
    `https://randomuser.me/api/portraits/${gender}/${number}.jpg`;
